import React from "react";
import "./App.css";
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./routes";

function App() {
  return (
    <Router basename="/">
      <AppRoutes />
    </Router>
  );
}

export default App;